import { TRACKERS } from "@/constants/Trackers";
import { Alerts } from "@/features/Patient/MedicalRecords/Alerts/Alerts";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/alerts")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_ALERTS);
  },
});

function RouteComponent() {
  return <Alerts />;
}
